export const brand = {
  DCS: 'DCS',
  HM: 'HM',
  LM: 'LM',
  RS: 'RS',
  YT: 'YT',
  AQUA: 'AQUA',
  MNP: 'MNP',
}

export const emptyCartButtonConfig: Record<string, Record<string, { buttons: { text: string, link: string }[] }>> = {
  [brand.DCS]: {
    TW: {
      buttons: [
        { text: '貓貓專區', link: '/product-category/cat/' },
        { text: '狗狗專區', link: '/product-category/dog/' },
      ],
    },
    HK: {
      buttons: [
        { text: '貓貓專區', link: '/product-category/cat/' },
        { text: '狗狗專區', link: '/product-category/dog/' },
      ],
    },
    SG: {
      buttons: [
        { text: '貓貓專區', link: '/product-category/shop-for-cat/' },
        { text: '狗狗專區', link: '/product-category/shop-for-dog/' },
      ],
    },
    MY: {
      buttons: [
        { text: '貓貓專區', link: '/product-category/shop-for-cat/' },
        { text: '狗狗專區', link: '/product-category/shop-for-dog/' },
      ],
    },
  },
  [brand.HM]: {
    TW: {
      buttons: [
        { text: '貓貓專區', link: '/product-category/mamaforcat/' },
        { text: '狗狗專區', link: '/product-category/mamafordog/' },
      ],
    },
    HK: {
      buttons: [
        { text: '貓貓專區', link: '/product-category/mamaforcat/' },
        { text: '狗狗專區', link: '/product-category/mamafordog/' },
      ],
    },
  },
  [brand.LM]: {
    TW: {
      buttons: [
        { text: '貓貓專區', link: '/product-category/cat/' },
        { text: '狗狗專區', link: '/product-category/dog/' },
      ],
    },
    HK: {
      buttons: [
        { text: '貓貓專區', link: '/product-category/cat/' },
        { text: '狗狗專區', link: '/product-category/dog/' },
      ],
    },
  },
  [brand.YT]: {
    TW: {
      buttons: [
        { text: '逛逛商品', link: '/product/' },
      ],
    },
  },
  [brand.AQUA]: {
    TW: {
      buttons: [
        { text: '逛逛商品', link: '/shop/' },
      ],
    },
    HK: {
      buttons: [
        { text: '逛逛商品', link: '/shop/' },
      ],
    },
  },
  [brand.RS]: {
    TW: {
      buttons: [
        { text: '逛逛商品', link: '/shop/' },
      ],
    },
  },
}
